export default "__VITE_ASSET__B6R_d0k2__"